import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ExternalLink, ShoppingBag, Instagram } from "lucide-react";
import { SITE } from "../lib/site";

export default function Clothing() {
  const [counting, setCounting] = useState(3);

  useEffect(() => {
    if (counting <= 0) {
      window.open(SITE.clothingUrl, "_blank", "noopener,noreferrer");
      return;
    }
    const t = setTimeout(() => setCounting((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [counting]);

  return (
    <section data-testid="clothing-page" className="min-h-[80vh] flex items-center pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-12 gap-6 md:gap-12 items-center"
        >
          <div className="col-span-12 md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-primary" />
              <span className="text-xs font-bold uppercase tracking-[0.3em] text-primary">The Shop</span>
            </div>
            <h1 className="font-display uppercase text-6xl md:text-8xl lg:text-9xl leading-[0.85] tracking-tight">
              BeGreat <br /><span className="text-primary">Clothing.</span>
            </h1>
            <p className="mt-8 max-w-xl text-foreground/75 text-base md:text-lg leading-relaxed">
              Gear up in the official BeGreat collection. We're sending you to the store now — if it doesn't open
              automatically, tap the button below.
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href={SITE.clothingUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="clothing-store-cta"
                className="group inline-flex items-center gap-3 bg-foreground text-background px-8 py-4 text-xs font-bold uppercase tracking-[0.25em] hover:bg-primary transition-colors"
              >
                <ShoppingBag size={16} /> Shop The Store
                <ExternalLink size={14} className="group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href={SITE.instagram}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-foreground/70 hover:text-primary transition-colors"
              >
                <Instagram size={14} /> DM us {SITE.instagramHandle}
              </a>
            </div>
            <div className="mt-12 inline-flex items-center gap-3 border border-foreground/20 px-4 py-3">
              <div className="font-display text-3xl text-primary leading-none w-10 text-center">{counting}</div>
              <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-muted-foreground leading-snug">
                Redirecting to <br /> the store
              </div>
            </div>
          </div>

          <div className="col-span-12 md:col-span-5">
            <div className="relative aspect-square bg-foreground text-background p-10 md:p-14 flex flex-col items-center justify-center text-center grain">
              <ShoppingBag size={48} className="text-primary" />
              <div className="mt-6 font-display uppercase text-5xl md:text-6xl leading-none">Shop</div>
              <div className="mt-2 font-display uppercase text-5xl md:text-6xl leading-none text-primary">BeGreat</div>
              <div className="mt-6 text-[10px] font-bold uppercase tracking-[0.3em] text-background/60">#BeUncommon</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
